/**
 * NSM home gallery preview — 6 images from config, links to /gallery.
 */
import React from "react";
import { Link } from "react-router-dom";
import { homePreviewItems } from "../../config/gallery";

export default function HomeGalleryPreview() {
  return (
    <section className="nsm-home-gallery">
      <div className="container">
        <h2 className="nsm-home-gallery__title section-title__title">
          Gallery
        </h2>
        <div className="nsm-home-gallery__grid">
          {homePreviewItems.map((item, index) => (
            <div key={index} className="nsm-home-gallery__item">
              <img src={item.image} alt={item.alt} />
              <Link to={`/gallery/${item.slug}`}>{item.name}</Link>
            </div>
          ))}
        </div>
        <div className="nsm-home-gallery__cta">
          <Link to="/gallery" className="thm-btn">
            View full gallery <span className="icon-arrow-right"></span>
          </Link>
        </div>
      </div>
    </section>
  );
}
